<template>
  <div class="base-table" :style="{height:height}">
    <div class="topbar">
      <div 
      :key="index" 
      v-for="(item, index) in data.tableHeader" 
      :style="{width: (data.tableHeaderWidth == 'avg') ? (100/data.tableHeader.length + '%') : data.tableHeaderWidth[index] }">{{item}}</div>
    </div>
    <div class="wrapper">
      <BScroll>
        <ul class="table">
          <li :key="index" v-for="(item, index) in data.tableBody">
            <div :key="index" v-for="(item, index) in data.tableBody[index]" :style="{width: (data.tableHeaderWidth == 'avg') ? (100/data.tableHeader.length + '%') : data.tableHeaderWidth[index] }">{{item}}</div>
          </li>
        </ul>
      </BScroll>
    </div>
  </div>
</template>

<script>
import BScroll from '@/components/Common/BScroll.vue'

export default {
  name: 'BaseTable',
  components: {
    BScroll
  },
  props: {
    height: {
      type: String,
      default: '4rem'
    },
    data: {
      type: Object,
      default() {
        return {
          tableHeaderWidth: 'avg', // 可传入具体数组 如 ['20%', '60%', '30px']
          tableHeader: ['qq', 'ww', 'ee'],
          tableBody: [[11, 22, 33], [11, 22, 33], [11, 22, 33]]
        }
      }
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang="less">
.base-table {
  width: 100%;
  .topbar {
    width: 100%;
    height: 0.38rem;
    color: @light-blue;
    font-weight: bold;
    position: relative;
    background: url(../../assets/remenluxian/table_topbar_bg.png);
    background-size: 100% 100%;
    border: 1px solid #0f84b9;
    overflow: hidden;
    > div {
      float: left;
      height: 0.36rem;
      line-height: 0.36rem;
      border-right: 1px solid #0f84b9;
    }
    div:last-child {
      border-right: none;
    }
  }
  .topbar::before {
    content: '';
    width: 0.02rem;
    height: 0.36rem;
    background: url(../../assets/remenluxian/table_topbar_line.png);
    background-size: 100% 100%;
    position: absolute;
    left: 0.04rem;
    top: 0;
  }
  .topbar::after {
    content: '';
    width: 0.02rem;
    height: 0.36rem;
    background: url(../../assets/remenluxian/table_topbar_line.png);
    background-size: 100% 100%;
    position: absolute;
    right: 0.04rem;
    top: 0;
  }
  .wrapper {
    overflow: hidden;
    width: 100%;
    height: calc(100% - 0.4rem);
  }
  .table {
    width: 100%;
    li {
      height: 0.36rem;
      line-height: 0.36rem;
      background: #07527c;
      border: 1px solid #0f84b9;
      border-bottom: none;
      font-size: 0.14rem;
      > div {
        height: 0.36rem;
        float: left;
        border-right: 1px solid #0f84b9;
      }
      div:last-child {
        border-right: none;
      }
    }
    li:nth-child(1) {
      border-top: none;
    }
    li:nth-of-type(odd) {
      background: rgba(6, 51, 81, 0.84);
    }
    li:last-child {
      border-bottom: 1px solid #0f84b9;
    }
  }
}
</style>
